import type { SiteStaffXatRank } from '@/lib/cms-types';
import type { PainelMockUser } from '@/lib/painel-rbac';
import type { XatOfficialRoleLabel } from '@/lib/xat-official-roles';
import {
  STAFF_XAT_RANK_OPTIONS,
  STAFF_XAT_RANK_PRESETS,
  optionIdToXatRank,
  xatRankToOptionId,
  type StaffXatRankOptionId,
} from '@/lib/equipe-xat-ranks';

/** Valor inicial do select a partir do utilizador (campo guardado ou preset por username). */
export function resolvePainelUserXatRankOptionId(
  user: Pick<PainelMockUser, 'username' | 'officialXatRole'>
): StaffXatRankOptionId | 'none' {
  if (user.officialXatRole === null) return 'none';
  if (user.officialXatRole) {
    const rank = STAFF_XAT_RANK_OPTIONS.find((o) => o.rank.label === user.officialXatRole)?.rank;
    if (rank) return xatRankToOptionId(rank);
  }
  const preset = STAFF_XAT_RANK_PRESETS[user.username.trim().toLowerCase()];
  return preset ? xatRankToOptionId(preset) : 'none';
}

export function xatRankOptionIdToOfficialLabel(
  id: StaffXatRankOptionId | 'none'
): XatOfficialRoleLabel | null {
  if (id === 'none') return null;
  const rank = optionIdToXatRank(id);
  return (rank?.label as XatOfficialRoleLabel | undefined) ?? null;
}

export function resolvePainelUserXatRank(
  user: Pick<PainelMockUser, 'username' | 'officialXatRole'>
): SiteStaffXatRank | null {
  if (user.officialXatRole === null) return null;
  if (user.officialXatRole) {
    const rank = STAFF_XAT_RANK_OPTIONS.find((o) => o.rank.label === user.officialXatRole)?.rank;
    if (rank) return rank;
  }
  return STAFF_XAT_RANK_PRESETS[user.username.trim().toLowerCase()] ?? null;
}
